var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.avatar)?_c('div',{staticClass:"avatar",class:{ tiny: _vm.tiny }},[_c('div',{staticClass:"avatar-inner"},[_c('img',{attrs:{"src":_vm.avatarImage(_vm.avatar)}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }